<template>
    <section>
        <div class="t-headline5 mt3">
            {{$t('1537')}}
            <!-- 소속 선택 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1538')}}
            <!-- 소속을 선택하세요. -->
        </div>
        <div class="mt88" v-if="responsibilityListLength">
            <div class="mt30" v-for="responsibility in responsibilityList" :key="responsibility.value">
                
                <div class="mdc-form-field">
                    <div class="mdc-radio radio-red">
                        <input class="mdc-radio__native-control" type="radio" 
                            :value="responsibility.value" 
                            :id="'responsibilityRadio'+responsibility.value"
                            v-model="selectedResponsibility">
                        <div class="mdc-radio__background">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                        </div>
                    </div>
                    <label :for="'responsibilityRadio'+responsibility.value">{{$t(responsibility.text)}}</label>
                </div>
            </div>
            
        </div>
        <div class="mt30" v-else>
            <div class="mdc-select mdc-select--outlined w-full" id="selectResponsibility">
                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                <select class="mdc-select__native-control" v-model="selectedResponsibility">
                    <option  value="">
                        {{$t('1543')}}
                    </option>
                    <option  v-for="responsibility in responsibilityList" :key="responsibility.value" :value="responsibility.value">
                        <!-- {{$t('responsibility.text')}} -->
                        {{responsibility.text}}
                    </option>
                </select>
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                        <!-- <label class="mdc-floating-label"></label> -->
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
        </div>
        <div class="mt64">
            <button class="mdc-button mdc-button--raised btn-red mr8" @click="next()">
                {{$t('1539')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1540')}}
                <!-- 취소 -->
            </button>
        </div>

        
        
    </section>
</template>

<script>
/**
 * 비밀번호 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언 S
import {MDCSelect} from '@material/select';
// import {MDCFormField} from '@material/form-field'
// import {MDCRadio} from '@material/radio'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            responsibilityList: {},
            selectedResponsibility: ''
        }
    },

    mixins: [joinMixin],

    created() {
        if (!this.join.role) {
            this.$router.go(-1)
        }
    },

    mounted() {
        this.setMaterialUi()

        joinApi.responsibility().then((response) => {
            this.responsibilityList = response.data.data
            console.log(this.responsibilityList)
            
            if (this.responsibilityListLength) {
                const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                    let button = new MDCRipple.attachTo(el)
                    return button
                })
            }else {
                const select = new MDCSelect(document.querySelector('#selectResponsibility'))
            }
        }).catch((err) => {
            console.log(err)
        })

        
    },

   
    computed: {
        ...mapState('join',{
            join : state => state,
        }),

        responsibilityListLength() {
            return this.responsibilityList.length <= 5 ? true : false
        }
    },


    methods: {
        ...mapMutations('join', ['SET_RESPONSIBILITY']),

        setMaterialUi() {

            if (!this.responsibilityListLength) {
               const select = new MDCSelect(document.querySelector('#selectResponsibility'))
            }
            
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 인증수단 조회 API 호출
        next() {
            if (this.selectedResponsibility) {
                this.SET_RESPONSIBILITY(this.selectedResponsibility)
                this.$router.push({
                    name: 'JoinPolicy', query: this.$route.query
                })
            }else {
                this.$snackOpen({
                    // contents:'소속을 선택해주세요.'
                    contents: this.$t('945'),
                    btnDisplay: ''
                    
                }).then(() => {})
            }
        },

        
        
    }
}
</script>

<style>

</style>
